<template>
  <button type="button" class="btn-like-action like-button" :class="likeClass" :disabled="isDisable" @click="addLike" :title="likeTitle">
    <i class="ico ico-favor"></i>
    <span class="alt-text">{{altText}}</span>
    <span>{{ count }}</span>
  </button>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'like-btn',
    props: ['likeCount', 'postId', 'isMemberPost'],
    data() {
      return {
        count: null,
        likeClass: '',
        likeTitle: '좋아요 버튼 하트 미표시된 상태',
        // altText: '좋아요 버튼 하트 미표시된 상태',
        isDisable: false,
      };
    },
    computed: {
      url() {
        return (this.isMemberPost) ? `/api/member-posts/${this.postId}/like` : `/api/posts/${this.postId}/like`;
      },
    },
    methods: {
      addLike() {
        axios.post(this.url).then((count) => {
          this.count = count.data;
          this.likeClass = 'is-active';
          this.likeTitle = '좋아요 버튼 하트 표시된 상태';
          // this.altText = '좋아요 버튼 하트 표시된 상태';
          this.isDisable = 'disabled';
        }).catch((error) => {
          alert(error.data.msg);
        });
      },
    },
    created() {
      this.count = this.likeCount;
    },
  };
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// LikeBtn.vue?15664f51